import { Modal, Typography } from "antd";
import { usePickupReceivers } from "hooks/pickup-receiver";
import { usePickupWarehouses } from "hooks/warehouse";
import { useEffect, useState } from "react";
import { notify } from "utils/helperFuncs";
import PickupWarehousePanel from "./PickupWarehousePanel";

const PickupWarehouseSelect = ({ visible, onClose, onConfirm, sellerID, initialWarehouseID, initialReceiverID }) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState();
  const [selectedReceiver, setSelectedReceiver] = useState();

  const { warehouses: companyOwnedWarehouses } = usePickupWarehouses(sellerID);
  const { handleGetPickupReceivers } = usePickupReceivers();

  // Modal này chọn xong mới bấm [Xác nhận] mới propagate ra ngoài (khác `PickupWarehousePanel` nhúng
  // thẳng trong popup đổi PTVC, chọn phát commit ngay) — nên cần tự resolve ID ban đầu thành object
  // đầy đủ để có sẵn khi user bấm [Xác nhận] mà không chạm lại lựa chọn nào.
  useEffect(() => {
    if (!visible) return;
    setSelectedWarehouse(companyOwnedWarehouses.find((w) => w.id === initialWarehouseID));
    if (initialReceiverID && sellerID) {
      handleGetPickupReceivers(sellerID).then((list) => {
        setSelectedReceiver((list || []).find((r) => r.id === initialReceiverID));
      });
    } else {
      setSelectedReceiver(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, initialWarehouseID, initialReceiverID, sellerID, companyOwnedWarehouses.length]);

  const handleConfirm = () => {
    if (!selectedWarehouse) {
      notify.warning({ message: "Vui lòng chọn kho nhận hàng" });
      return;
    }
    if (!selectedReceiver) {
      notify.warning({ message: "Vui lòng chọn người nhận hàng" });
      return;
    }
    onConfirm({
      warehouseID: selectedWarehouse.id,
      receiverID: selectedReceiver.id,
      warehouse: selectedWarehouse,
      receiver: selectedReceiver,
    });
  };

  return (
    <Modal
      title={
        <Typography.Text strong style={{ fontSize: 16 }}>
          Nhận hàng tại kho
        </Typography.Text>
      }
      visible={visible}
      onCancel={onClose}
      onOk={handleConfirm}
      okText="Xác nhận"
      cancelText="Hủy"
      width={600}
      centered
      bodyStyle={{ padding: 0 }}
      okButtonProps={{ style: { background: "#2563EB", borderColor: "#2563EB" } }}
    >
      <PickupWarehousePanel
        sellerID={sellerID}
        selectedWarehouseID={selectedWarehouse?.id}
        selectedReceiverID={selectedReceiver?.id}
        onSelectWarehouse={setSelectedWarehouse}
        onSelectReceiver={setSelectedReceiver}
      />
    </Modal>
  );
};

export default PickupWarehouseSelect;
